import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { ITransferEmployeeTransactionRecordDto } from "../../../dtos/transactions/ITransferEmployeeTransactionRecordDto";

interface IProps {
  items: ITransferEmployeeTransactionRecordDto[];
}

export const TransferEmployeeTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column width={150} dataField="period" dataType={"datetime"} caption="Period" sortOrder={"asc"} sortIndex={1} />
          <Column width={150} dataField="documentId" dataType={"string"} caption="Document " />
          <Column width={150} dataField="employeeId" dataType={"string"} caption="Employee " />
          <Column width={150} dataField="companyId" dataType={"string"} caption="Company " />
          <Column width={150} dataField="transferDate" dataType={"datetime"} caption="Transfer Date" />
          <Column width={150} dataField="operationType" dataType={"number"} caption="Operation Type" />
          <Column width={150} dataField="newWorkScheduleId" dataType={"string"} caption="New Work Schedule " />
          <Column width={150} dataField="newPositionId" dataType={"string"} caption="New Position " />
          <Column width={150} dataField="newSalary" dataType={"number"} caption="New Salary" />
          <Column width={150} dataField="newDivisionId" dataType={"string"} caption="New Division " />

          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
